<template>
  <b-card title="Procesamiento de documentos">
    <form v-if="!loading" @keydown.enter.prevent autocomplete="off" data-vv-scope="inputDoc">
      <hr class="">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Destinatario</h4>
          <small class="text-danger" v-if="error.subject">{{error.subject}}</small>
          <SelectSubject @add-subject="addSubject" />
        </div>
        <div class="col-12">
          <TableSubjects :subjects="subjects"/>
          <small class="text-primary">
            Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual
          </small>
        </div>
      </div>
      <hr class="">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Con copia a</h4>
          <SelectCopy @add-copy="addCopy" />
        </div>
        <div class="col-12">
          <TableCopies :copies="copies" @removeCopy="removeCopy"/>
        </div>
      </div>
      <hr class="">
      <div class="row mt-3" v-if="typeof importedFile === 'undefined'">
        <div class="col-12 mt-2">
          <LoadFiles
            v-model="inputFormat"
            @mainFile="mainFile = $event"
            @additionalFiles="additionalFiles = $event"
            :withTrueCopy="true"
          />
          <small class="text-danger" v-if="error.onlyPdf">{{error.onlyPdf}}</small>
          <small class="text-danger pl-1" v-if="error.mainFile">{{error.mainFile}}</small>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 mt-5 text-right">
          <vs-button class="mr-2 btn btn-success" @click="save" :disabled="loading">
            Guardar
          </vs-button>
          <vs-progress
            class="mb-1 mt-2"
            v-if="loading"
            indeterminate
            color="primary"
          />
        </div>
      </div>
    </form>
    <Confirm
      :motherDocNumber="motherDocNumber"
      :isMotherDocument="isMotherDocument"
      :resetData="resetData"
      :dntCode="dntCode"
      :showConfirm="showConfirm"
      @closeModal="closeConfirm"
      :state="state"
      :fromEditActioon="fromEditAction"
    />
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import InterestAreas from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/InterestAreas';
import Confirm from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/Confirm';
import LoadFiles from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/LoadFiles';
import SelectSubject from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/SelectSubject';
import SelectCopy from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/SelectCopy';
import TableSubjects from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/TableSubjects';
import TableCopies from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/TableCopies';
import RutMixin from '@/febos/chile/_vue/mixins/RutMixin';
import InputProps from '@/febos/chile/dnt/components/wizard/companies/60100003-2/mixins/InputProps';
import { ioExpedientesSearch } from '@/febos/servicios/api/busqueda.api';
import { listOptions } from '@/febos/servicios/api/opciones.api';

export default {
  name: 'DocumentProcessingMeta',
  components: {
    LoadFiles,
    SelectSubject,
    SelectCopy,
    TableSubjects,
    TableCopies,
    Confirm
  },
  mixins: [RutMixin, InputProps],
  props: ['notify', 'previousRoute'],
  data() {
    return {
      interestAreas: InterestAreas,
      loadingMotherDocuments: false,
      motherDocumentsFullList: [],
      showListSelect: false,
      importedFile: undefined,
      externAuthorsRoles: []
    };
  },
  watch: {
    sender(val, oldVal) {
      if (oldVal === 'stateAgency') {
        this.agency = 'legislativePower';
      }
      this.$validator.reset();
    },
    classification(val) {
      if (this.fromEditAction) {
        return;
      }
      if (!val) this.docCode = '';
      if (val) this.docCode = `${val}-#`;
    },
    documentType(val, oldVal) {
      if (oldVal && val !== oldVal) {
        this.adhesion = undefined;
        this.proposalStatus = undefined;
        this.commissions = undefined;
      }
    }
  },
  computed: {
    ...mapGetters('Dnts', ['communes', 'loading', 'wizardStorage', 'detailsFile']),
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('Empresas', ['company']),
    isPaper() {
      return this.inputFormat === 'paper';
    },
    isPaperAndDigital() {
      return this.inputFormat === 'paper_digital';
    },
    isDigital() {
      return this.inputFormat === 'digital';
    },
    fromDocDigital() {
      return this.$route.params.from === 'docDigital';
    },
    fromDraftTray() {
      return this.$route.params.from === 'draftTray';
    },
    fromEditAction() {
      return this.$route.params.from === 'edit';
    },
    showContactData() {
      return !this.agency.match(/centralAdministration|docDigital/)
        && this.sender !== 'conventional' && this.sender !== 'commission';
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'createConventionDnt',
      'listDocuments',
      'editConventionDnt',
      'getFileDnt',
      'setWizardStorageFile'
    ]),
    closeConfirm() {
      this.showConfirm = false;
      if (this.fromEditAction) {
        this.resetData();
        this.$router.push({ name: 'files', params: { view: 'completitudDatos' } });
      }
    },
    formatDate(fullDate) {
      const date = fullDate.split(' ')[0];
      const year = date.split('-')[0];
      const month = date.split('-')[1];
      const day = date.split('-')[2];
      const months = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      return `${day} de ${months[parseInt(month, 10)]}, ${year}`;
    },
    selectCommission(commission) {
      this.name = commission.label;
    },
    async searchForMother() {
      this.showListSelect = true;
      this.loadingMotherDocuments = true;
      const payload = {
        params: {
          elementosPorPagina: 5,
          pagina: 1,
          filtros: `numero$${this.motherDocNumber}|emisorRut:${this.company.iut}|estado:!!!3|estadoCodigoEstadoComprador:1|id:!!!${this.$route.query.febosId}`,
          orden: '-fechaCreacion'
        }
      };
      try {
        const res = await ioExpedientesSearch(payload);
        const that = this;
        res.data.documentos.forEach((element) => that.motherDocumentsFullList.push(element));
        const keys = ['numero$', 'fechaCreacion'];
        this.motherDocumentsFullList = this.motherDocumentsFullList.filter(
          // this basically delete duplicates, using added keys before
          ((s) => (o) => ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join('|')))(new Set())
        );
      } catch (e) {
        // nothing to do
      }
      this.loadingMotherDocuments = false;
    },
    async save(status) {
      const validForm = await this.validateForm();
      if (!validForm) return;

      if (!this.fromEditAction) {
        const ENTERED = 2;
        const DRAFT = 3;
        const FINISHED = 9;
        if (typeof this.importedFile === 'undefined') {
          this.state = status === 'draft' ? DRAFT : ENTERED;
        } else {
          this.state = status === 'draft' ? DRAFT : FINISHED;
        }
      }

      const data = {
        destinatarios: this.getSubjects(),
        dnt: this.detailsFile.dnt,
        adjuntos: this.getAttachments()
      };

      const { febosId } = this.$route.query;

      let response = '';
      data.dnt.febosId = febosId;
      response = await this.editConventionDnt(data);
      await this.loadSavedData();
      await this.getFileDnt({
        febosId: this.$route.query.febosId,
        dnt: 'si',
        retornarDnt: 'si',
        destinatarios: 'si',
        etiquetas: 'si',
        referencias: 'si',
        adjuntos: 'si',
        metadata: 'si',
        docDigitalAutores: 'si',
        docDigitalParticipantes: 'si'
      });
      await this.fillDraftData();
      this.$emit('close-modal');
      this.dntCode = response.numero;
      this.showConfirm = true;
    },
    async loadSavedData() {
      await this.fillDraftData();
      this.state = this.detailsFile.dnt.estado;
      await this.$validator.reset();
    },
    closeModalMetadata() {
      this.$refs.modalMetadata.hide();
    }
  },
  created() {
    this.loadSavedData();
  },
  async mounted() {
    const response = await listOptions({
      grupoOpcion: 'roles-usuarios-convencion',
      deshabilitado: 'no'
    });
    this.externAuthorsRoles = response.data.opciones;
  }
};
</script>
<style scoped>
#list {
  font-size: 12px;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  background-color: white;
  border-radius: 0 0 5px 5px;
  border: 1px #ccc solid;
  position: absolute;
  z-index:100;

}

#list li {
  display: block;
  padding: 5px 15px;
}

#list li:hover {
  background-color: #ccc;
  /*   color: white; */
}

#list li span {
  font-weight: 550;
}

#list li p {
  margin: 5px 0 0;
}
.muted-light{
  color:#aaa;
  font-weight:100;
}
</style>
